<form [formGroup]="formGroup">

  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc.visit.masterdata.title"></sc-dictionary-label>
  </sc-sub-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-string-field grow formControlName="firstName" [required]="true"
      [label]="'firstname' | translate: ['tmc.visit.masterdata.firstname', translationService.language]">
    </sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field grow formControlName="name" [required]="true"
      [label]="'name' | translate: ['tmc.visit.masterdata.name', translationService.language]">
    </sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field grow formControlName="company"
      [label]="'company' | translate: ['tmc.visit.masterdata.company', translationService.language]">
    </sc-string-field>
  </sc-flex>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex>
    <sc-string-field [grow]="false" formControlName="personalId" [required]="idNumberRequired"
      [label]="'personalId' | translate: ['tmc.visit.masterdata.personalId', translationService.language]">
    </sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>{{'Besuchertyp' | translate:['tmc.visit.masterdata.type', translationService.language]}}</mat-label>
      <mat-select [required]="true" formControlName="visitorType">
        <mat-option *ngFor="let type of types" [value]="type">
          {{'' | translate: [type.dictionaryKey, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-checkbox-field formControlName="confirmed" labelDictionaryKey="tmc.visit.masterdata.confirmed" class="no-wrap"></sc-checkbox-field>
  </sc-flex>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>

    <ng-container *ngIf="upfrontRegistration">
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-date-time-field [required]="true" formControlName="plannedArrival"
        [label]="'planned arrival' | translate:['tmc.visit.masterdata.plannedArrival',translationService.language]">
      </sc-date-time-field>
    </ng-container>

    <sc-content-spacer></sc-content-spacer>

    {{'End Date Role' | translate:['tmc.visit.masterdata.endByRole',translationService.language]}}
    <sc-content-spacer></sc-content-spacer>
    {{formatEndByRoleDate(visit.endByRole)}}

    <sc-content-spacer grow></sc-content-spacer>

    <sc-checkbox-field formControlName="defineEndDate"
      [label]="'Abweichendes Endedatum' | translate:['tmc.visit.masterdata.defineEndDate',translationService.language]">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-date-field formControlName="definedEndDate"
      [label]="'End Date' | translate:['tmc.visit.masterdata.definedEndDate',translationService.language]"
      [required]="visit.defineVisitEnd">
    </sc-date-field>

  </sc-flex>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-checkbox-field formControlName="sendVisitorMail"
      [label]="'send mail' | translate:['tmc.visit.masterdata.sendMail',translationService.language]">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field grow formControlName="visitorMail"
      [label]="'mail' | translate: ['tmc.visit.masterdata.mail', translationService.language]">
    </sc-string-field>
  </sc-flex>

  <sc-content-spacer vertical double></sc-content-spacer>

  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc.visit.masterdata.title-invitation-parameters"></sc-dictionary-label>
  </sc-sub-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-checkbox-field formControlName="inviteAdditionalVisitorsAllowed"
    [label]="'Invite Additional Visitors Allowed' | translate:['tmc.visit.masterdata.inviteAdditionalVisitorsAllowed',translationService.language]">
  </sc-checkbox-field>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-checkbox-field formControlName="invitationRequiresConfirmation"
    labelDictionaryKey="tmc.visit.masterdata.invitationRequiresConfirmation"></sc-checkbox-field>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex>
    <sc-content-spacer double></sc-content-spacer>
    <sc-checkbox-field formControlName="invitationConfirmationOnAccessOnly"
      labelDictionaryKey="tmc.visit.masterdata.invitationConfirmationOnAccessOnly"></sc-checkbox-field>
  </sc-flex>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-checkbox-field formControlName="assignPrivilegesOnInvitation"
    labelDictionaryKey="tmc.visit.masterdata.assignPrivilegesOnInvitation"></sc-checkbox-field>

  <sc-content-spacer vertical double></sc-content-spacer>

  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc.visit.masterdata.title-vehicle-usage"></sc-dictionary-label>
  </sc-sub-title>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-checkbox-field formControlName="withCar"
      [label]="'with car' | translate:['tmc.visit.masterdata.withCar',translationService.language]">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field grow formControlName="numberplate"
      [label]="'numberplate' | translate: ['tmc.visit.masterdata.numberplate', translationService.language]">
    </sc-string-field>
  </sc-flex>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex>
    <sc-checkbox-field formControlName="needsAreaAccessByCar"
      [label]="'needs area access by car' | translate:['tmc.visit.masterdata.needsAreaAccessByCar',translationService.language]">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-checkbox-field formControlName="grandAreaAccessByCar"
      [label]="'grand area access by car' | translate:['tmc.visit.masterdata.grandAreaAccessByCar',translationService.language]">
    </sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-checkbox-field formControlName="grandAreaAccessOnFoot"
      [label]="'grand area access by feed' | translate:['tmc.visit.masterdata.grandAreaAccessOnFoot',translationService.language]">
    </sc-checkbox-field>
  </sc-flex>


</form>
